import { getBuilderChatEnabled } from '../builderChat';

/**
 * Отображается ли кнопка чата.
 * Если в кнопку добавляется возможность открыть новый вид чата, то нужно добавить условие в этот селектор.
 */
export const selectMessageButtonAvailable = getBuilderChatEnabled;
